module.exports = __webpack_public_path__ + "img/export-to-doc.af027881.svg";